import React, { useEffect, useState } from "react";
import { InputFieldKYC, TextAreaField } from "./Kycform";
import { Form } from "react-bootstrap";
import { TiDeleteOutline } from "react-icons/ti";
import Button from 'react-bootstrap/Button';
import {
    BUSINESS_ROLE,
  COMPLIANCE_APPROVED,
  COMPLIANCE_NEW,
  COMPLIANCE_PENDING,
  COMPLIANCE_REJECTED,
  INVESTOR_ROLE,
} from "../utilities";
import { CRYPTO_SECRET_KEY } from "../utilities";
import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie';
import moment from "moment";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { decrypt } from "../utils";
import { FaEyeIcon } from "../InvestorFlow/InvestorSettingsIndividual";
import { useRef } from 'react';
import { FaEye } from "react-icons/fa";
export const BusinessSettings = ({
  download,
  handleUpdateKyc,
  handleSavechanges,
  saveKYCBtn,
  handleChangeDownload,
  handleChange,
  updatedBanks,
  handleBankChange,
  rejectedBanks,
  updatedSuppliers,
  plusDisabled,
  handleSupplierChange,
  rejectedSuppliers,
  updatedCustomers,
  getDocuments,
  handleCustomerChange,
  shareHolderData,
  rejectedCustomers,
  handleAddRow,
  handleInputChange,
  rejectedShareHolderData,
  defaultvalue,
  handleRemoveRow,
  statusFlag,
  handleSubmit,
  handleFieldChange,
  rejectedDetails,
  formData,
  rejectedFlag,
  dataUser,
  masterData,
  handleDeleteClick,
  handleSaveDraft,
  mergedDownloads,
  handleSaveDraftCompany,
 handleIsDataNull,
 handleChangeDownloadForOthers,
 others,
 handleDeleteClickOthers,
}) => {
  const fileInputRef = useRef(null);
 var currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const tomorrow = currentDate.toISOString().split("T")[0];

  const [role_code,setRoleCode]=useState(Cookies.get("role_code"));

  useEffect(()=>{
    if(role_code){
      const decryptedValueData = decrypt(role_code)
      setRoleCode(decryptedValueData);
    }
  },[])


  return (
    <p className="paragraph">
      {masterData?.status === COMPLIANCE_REJECTED && (
        <div className="rejected_reason ms-2 m-3 mb-4 d-flex justify-content-between">
          <div>
            <span className="text-danger">Reason for Rejection :</span>
            <span> {masterData?.admin_notes}</span>
          </div>
        </div>
      )}
   {role_code == BUSINESS_ROLE ?   <div className="row gap-lg-3">
        <InputFieldKYC
          label={"Name Of the Business"}
          placeholder={dataUser?.business_name ? dataUser?.business_name:dataUser?.investor_company_name}
          disabled={true}
        />

        <InputFieldKYC
          label={"Type of Business"}
          placeholder={dataUser?.business_type}
          disabled={true}
        />

        <InputFieldKYC
          label={"Email"}
          placeholder={dataUser?.email}
          disabled={true}
        />
      </div> :
      <div className="row gap-lg-3">
        <InputFieldKYC
          label={"Name of the Business"}
          placeholder={dataUser?.investor_company_name}
          disabled={true}
        />

        <InputFieldKYC
          label={"Type of Business"}
          placeholder={dataUser?.type}
          disabled={true}
        />

        <InputFieldKYC
          label={"Email"}
          placeholder={dataUser?.email}
          disabled={true}
        />
      </div> }

      <div className="row gap-lg-3 mt-2">
        <InputFieldKYC
          label={"Phone"}
          placeholder={dataUser?.phone}
          disabled={true}
        />

        <div className="col-md settings_YOE ">
          
          <InputFieldKYC
          disabled={true}
          label={"Country of Business"}
          placeholder={dataUser?.country}
        />
        </div>
        <InputFieldKYC
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
          label={"Sector"}
          mandatory={"*"}
          placeholder={"Sector"}
          value={
            (masterData && statusFlag === COMPLIANCE_PENDING) ||
            statusFlag === COMPLIANCE_APPROVED
              ? masterData.sector
              : masterData && statusFlag === COMPLIANCE_REJECTED
              ? rejectedDetails?.sector
              : formData?.sector
          }          
          onChange={(e) => handleFieldChange("sector", e.target.value)}
        />
      </div>
      <div className="row gap-lg-3 mt-2">
      




        <TextAreaField
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
          label={"Address (as per address proof) "}       
          row={2}
          mandate={"*"}
          id="address"
          name="address"
          value={
                  masterData &&
                  (statusFlag === COMPLIANCE_PENDING ||
                    statusFlag === COMPLIANCE_APPROVED)
                    ? masterData.registered_address
                    : masterData && statusFlag === COMPLIANCE_REJECTED
                    ? rejectedDetails?.registered_address
                    : formData?.registered_address
                }
          onChange={(e) => handleFieldChange("registered_address", e.target.value)}
        />

      </div>

      <div className="row gap-lg-3 mt-3">
        <div className="col">
         
          <InputFieldKYC label={"Place of Incorporation/Establishment"} type={"text"}  
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
            mandatory={"*"}
            htmlFor={"place_of_incorporation"}
            name="place_of_incorporation"
            id="place_of_incorporation"
            value={
                masterData && statusFlag === COMPLIANCE_APPROVED
                  ? masterData.place_of_incorporation
                  : masterData && statusFlag === COMPLIANCE_PENDING
                  ? masterData.place_of_incorporation
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.place_of_incorporation
                  :
                   formData?.place_of_incorporation
              }
              placeholder="Place of Incorporation/Establishment"
              onChange={(e) =>handleFieldChange("place_of_incorporation", e.target.value) }
          />
          
        </div>
        <div className="col-lg-3">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf ">
            <label htmlFor="typeofbusns">
              <p> Date of Incorporation<span style={{ color: "red" }}>*</span> </p>
            </label>
            <input
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              type="date"
              
              max={new Date().toISOString().split('T')[0]}
              name="date_of_incorporation"
              id="date_of_incorporation"
              className="form-control bg-white text-start"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED )
                  ? (masterData.date_of_incorporation ? moment(masterData.date_of_incorporation).format(
                      "YYYY-MM-DD"
                    ):"")
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ?(rejectedDetails?.date_of_incorporation ?  moment(rejectedDetails?.date_of_incorporation).format(
                      "YYYY-MM-DD"
                    ):"")
                  : 
                  moment(formData?.date_of_incorporation).format(
                    "YYYY-MM-DD"
                  )
              }
              placeholder="Date of Incorporation"
              onChange={(e) =>
                handleFieldChange("date_of_incorporation", e.target.value)
              }
            />
          </form>
        </div>
      </div>

      <div className="row gap-lg-3 mt-3">
        <div className="col">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            <label htmlFor="typeofbusns">
              <p>
                {" "}
                Trade License Number <span style={{ color: "red" }}>*</span>
              </p>
            </label>
            <input
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              type="text"
              name="trade_license_no"
              id="trade_license_no"
              className="form-control bg-white"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.trade_license_no
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.trade_license_no
                  : formData?.trade_license_no
              }
              placeholder="Trade License Number"
              onChange={(e) =>
                handleFieldChange("trade_license_no", e.target.value)
              }
            />
          </form>
        </div>

        <div className="col-lg-3 ">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            <label htmlFor="typeofbusns">
              <p>
                {" "}
                Trade License Expiry Date{" "}
                <span style={{ color: "red" }}>*</span>
              </p>
            </label>

            <input
              type="date"
              disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              name="trade_license_expiry_date"
              min={tomorrow}
              id="trade_license_expiry_date"
              className="form-control bg-white text-start"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? moment(masterData.trade_license_expiry_date).format(
                      "YYYY-MM-DD"
                    )
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? moment(rejectedDetails?.trade_license_expiry_date).format(
                      "YYYY-MM-DD"
                    )
                  : 
                  moment(formData?.trade_license_expiry_date).format(
                    "YYYY-MM-DD"
                  )
              }
              placeholder="Trade License Expiry Date"
              onChange={(e) =>
                handleFieldChange("trade_license_expiry_date", e.target.value)
              }
            />
         </form>
        </div>
      </div>

      <div className="row gap-lg-3 mt-2">
        <TextAreaField
          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
          label={"Description Of Business"}
          mandate={"*"}
          row={2}
          id="description_of_business"
          name="description_of_business"
          value={
            masterData &&
            (statusFlag === COMPLIANCE_PENDING ||
              statusFlag === COMPLIANCE_APPROVED)
              ? masterData.description_of_business
              : masterData && statusFlag === COMPLIANCE_REJECTED
              ? rejectedDetails?.description_of_business
              : formData?.description_of_business
          }
          onChange={(e) =>
            handleFieldChange("description_of_business", e.target.value)
          }
        />
      </div>
      <div className="col-lg mt-3">
        <TextAreaField
        mandate={"*"}
        disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
          label={"Ultimate Beneficial Owner (UBO) and % holding"}
          row={2}
          id="beneficial_owner_with_percentage_holding"
          name="beneficial_owner_with_percentage_holding"
          placeholder="Beneficial Owner With Percentage Holding"
          value={
            masterData &&
            (statusFlag === COMPLIANCE_PENDING ||
              statusFlag === COMPLIANCE_APPROVED)
              ? masterData.beneficial_owner_with_percentage_holding
              : masterData && statusFlag === COMPLIANCE_REJECTED
              ? rejectedDetails?.beneficial_owner_with_percentage_holding
              : formData?.beneficial_owner_with_percentage_holding
          }
          onChange={(e) =>
            handleFieldChange(
              "beneficial_owner_with_percentage_holding",
              e.target.value
            )
          }
        />
      </div>

      <div className="row gap-lg-3 mt-2">
        <div>
        
          <table className="kyc_table">
            <thead >
              <tr  >
                <th>Name Of Shareholder (All above 5% shareholding)<span style={{color:"red"}}>*</span></th>
                <th>Designation<span style={{color:"red"}}>*</span></th>
                <th>Nationality<span style={{color:"red"}}>*</span></th>
                <th>Date Of Birth<span style={{color:"red"}}>*</span></th>
                <th>Country of Residence<span style={{color:"red"}}>*</span></th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {masterData &&
                statusFlag !== COMPLIANCE_NEW &&
                rejectedShareHolderData?.map((i, index) => {
                  return (
                    <tr key={index} className="shareholder_tab">
                      <td >
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          name="name_of_shareholder"
                          placeholder="Name"
                          value={ statusFlag === COMPLIANCE_REJECTED  ? rejectedShareHolderData[index]?.name_of_shareholder : i?.name_of_shareholder}                                                                                                 
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "name_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>                        
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={
                             statusFlag === COMPLIANCE_REJECTED
                             ? rejectedShareHolderData[index]
                                  .designation_of_shareholder
                               : i.designation_of_shareholder
                          }
                          name="designation_of_shareholder"
                          placeholder="Shareholder/signatory"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "designation_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={
                            statusFlag === COMPLIANCE_REJECTED
                            ? rejectedShareHolderData[index]
                            .nationality_of_shareholder
                        : i.nationality_of_shareholder
                          }
                          placeholder="Nationality"
                          name="nationality_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "nationality_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="date"
                          value={
                            statusFlag === COMPLIANCE_REJECTED
                            ? rejectedShareHolderData[index]
                            .dob_of_shareholder
                        : i.dob_of_shareholder
                          }
                          placeholder="Date Of Birth"
                          max={new Date().toISOString().split('T')[0]}
                          min={"1900-01-01"}
                          name="dob_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "dob_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={
                            statusFlag === COMPLIANCE_REJECTED
                            ? rejectedShareHolderData[index]
                            .residential_country_of_shareholder  
                            : i.residential_country_of_shareholder
                          }
                          placeholder="Country"
                          name="residential_country_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "residential_country_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <div>
                          <span
                            onClick={() => handleRemoveRow(index)}
                            className="remove-row-button"
                            style={{
                              cursor:index===0 ? "not-allowed":"pointer",
                              fontSize: "2.0em",
                              marginRight: "5px",
                            }}
                          >
                            <AiFillMinusCircle disabled/>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {masterData?.length === 0 || statusFlag === COMPLIANCE_NEW
                ? shareHolderData?.map((row, index) => (
                    <tr key={index} className="shareholder_tab">
                      <td >
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          name="name_of_shareholder"
                          value={row.name_of_shareholder}
                          placeholder="Name"
                          className="form-control bg-white"
                          onChange={(e) =>{
                            handleInputChange(
                              index,
                              "name_of_shareholder",
                              e.target.value
                            )
                          }
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={row.designation_of_shareholder}
                          name="designation_of_shareholder"
                          placeholder="Shareholder/signatory"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "designation_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={row.nationality_of_shareholder}
                          placeholder="Nationality"
                          name="nationality_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "nationality_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="date"
                          value={row.dob_of_shareholder}
                          placeholder="Date Of Birth"
                          max={new Date().toISOString().split('T')[0]}
                          min={"1900-01-01"}
                          name="dob_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "dob_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          value={row.residential_country_of_shareholder}
                          placeholder="Country"
                          name="residential_country_of_shareholder"
                          className="form-control bg-white"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "residential_country_of_shareholder",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <div>
                          {<span
                            onClick={() => handleRemoveRow(index)}
                            className="remove-row-button"
                            style={{
                              cursor:index===0 ? "not-allowed":"pointer",
                              fontSize: "2.0em",
                              marginRight: "5px",
                            }}
                          >
                            <AiFillMinusCircle disabled />
                          </span>}
                        </div>
                      </td>
                    </tr>
                  ))
                : ""}
            </tbody>
          </table>
          <span
            onClick={handleAddRow}
            style={{
              fontSize: "2.0em",
              marginRight: "5px",
              cursor: plusDisabled ? "" : "pointer",
            }}
            className="me-3"
          >
            {" "}
            {(masterData?.length === 0 ||
              statusFlag === COMPLIANCE_NEW || statusFlag===COMPLIANCE_REJECTED) && <AiFillPlusCircle/>}
          </span>
        </div>
      </div>

      <div className="row gap-lg-3 mt-2">
        <div className="col-lg">
          <TextAreaField
            disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
            label={"List products/services by the company"}
            mandate={"*"}
            row={2}
            id="products_by_the_company"
            name="products_by_the_company"
            placeholder="List of products/ services by the company"
            value={
              masterData &&
              (statusFlag === COMPLIANCE_PENDING ||
                statusFlag === COMPLIANCE_APPROVED)
                ? masterData.products_by_the_company
                : masterData && statusFlag === COMPLIANCE_REJECTED
                ? rejectedDetails?.products_by_the_company
                : formData?.products_by_the_company
            }
            onChange={(e) =>
              handleFieldChange("products_by_the_company", e.target.value)
            }
          />
        </div>

        <div className="row gap-lg-3 mt-2">
          <div className="col-lg">
            <TextAreaField
              disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              mandate={"*"}
              label={
                "List the country of origin of products/services dealt by the company"
              }
              row={2}
              id="origin_of_products"
              name="origin_of_products"
              placeholder="ex. China, USA "
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.origin_of_products
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.origin_of_products
                  : formData?.origin_of_products
              }
              onChange={(e) =>
                handleFieldChange("origin_of_products", e.target.value)
              }
            />
          </div>
        </div>
        <div className="row gap-lg-3 mt-2">
          <div className="col-lg">
            <TextAreaField
              disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              mandate={"*"}
              label={
                "List the countries where the company imports their products along with % (ex.China 50%, USA 50%)"
              }
              row={2}
              id="import_countries_with_percentage"
              name="import_countries_with_percentage"
              placeholder="ex. China 50%, USA 50%"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.import_countries_with_percentage
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.import_countries_with_percentage
                  : formData?.import_countries_with_percentage
              }
              onChange={(e) =>
                handleFieldChange(
                  "import_countries_with_percentage",
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div className="row gap-lg-3 mt-2">
          <div className="col-lg">
            <TextAreaField
              disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              mandate={"*"}
              label={
                "List the countries where the company directly sells its products/services along with %.(ex.Bahrain 100%) "
              }
              row={2}
              id="export_countries_with_percentage"
              name="export_countries_with_percentage"
              placeholder="ex. Bahrain 100%"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.export_countries_with_percentage
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.export_countries_with_percentage
                  : formData?.export_countries_with_percentage
              }
              onChange={(e) =>
                handleFieldChange(
                  "export_countries_with_percentage",
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div className="row gap-lg-3 mt-2">
          <div className="col-lg">
            <TextAreaField
              disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
              mandate={"*"}
              label={
                "List the ultimate destination where the company’s products would be re-exported to.(ex.Bahrain 100%)"
              }
              row={2}
              id="re_export_countries_with_percentage"
              name="re_export_countries_with_percentage"
              placeholder="ex. Bahrain 100%"
              value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.re_export_countries_with_percentage
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.re_export_countries_with_percentage
                  : formData?.re_export_countries_with_percentage
              }
              onChange={(e) =>
                handleFieldChange(
                  "re_export_countries_with_percentage",
                  e.target.value
                )
              }
            />
          </div>
        </div>
      </div>

      <div className="row gap-lg-3 mt-3">
        <div className="col-lg">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            <div className="row ">
              {
                <div className="col mt-2">
                  <label htmlFor="topCustomers" style={{ fontSize: "14px" }}>
                    List top 5 customers (buyers) of the company<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
              }

              <div className="col-lg-8">
                {masterData &&
                   statusFlag !== COMPLIANCE_NEW &&
                  masterData?.top_5_customers?.map((i, index) => {
                    return (
                      <div className="mb-2" key={index}>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          name={`customer${index}`}
                          id={`customer${index}`}
                          className="form-control bg-white"
                          placeholder={`Customer ${index + 1}`}
                          value={
                            masterData &&
                            statusFlag === COMPLIANCE_REJECTED
                              ? rejectedCustomers[index]
                              : i
                          }
                          onChange={(e) =>
                            handleCustomerChange(index, e.target.value)
                          }
                        />
                      </div>
                    );
                  })}
                {(masterData?.top_5_customers?.length === 0 ||
                  masterData?.length === 0 ||
                  statusFlag === COMPLIANCE_NEW) &&
                  [1, 2, 3, 4, 5].map((i, index) => {
                    return (
                      <div className="mb-2" key={index}>
                        <input
                          disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                          type="text"
                          name={`customer${index}`}
                          id={`customer${index}`}
                          className="form-control bg-white"
                          placeholder={`Customer ${index + 1}`}
                           value={updatedCustomers[index]}
                          onChange={(e) =>
                            handleCustomerChange(index, e.target.value)
                          }
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="row gap-lg-3 mt-3">
        <div className="col-lg">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            <div className="row ">
              {
                <div className="col mt-2">
                  <label htmlFor="topCustomers " style={{ fontSize: "14px" }}>
                    List of top 5 suppliers of the company<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
              }
              <div className="col-lg-8">
                {masterData &&
                  statusFlag !== COMPLIANCE_NEW &&
                  masterData?.top_5_suppliers?.map((i, index) => (
                    <div className="mb-2" key={index}>
                      <input
                        disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                        type="text"
                        className="form-control bg-white"
                        value={
                          masterData &&
                          statusFlag === COMPLIANCE_REJECTED
                            ? rejectedSuppliers[index]
                            : i
                        }
                        onChange={(e) =>
                          handleSupplierChange(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
                {(masterData?.top_5_suppliers?.length === 0 ||
                  masterData?.length === 0 ||
                  statusFlag === COMPLIANCE_NEW) &&
                  [1, 2, 3, 4, 5].map((i,index) => (
                    <div className="mb-2" key={index}>
                      <input
                        disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                        type="text"
                        name={`suppliers${index}`}
                        id={`suppliers${index}`}
                        className="form-control bg-white"
                        placeholder={`Supplier ${i}`}
                        value={updatedSuppliers[index]}
                        onChange={(e) =>
                          handleSupplierChange(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
          </form>
        </div>
      </div>
      {role_code == BUSINESS_ROLE && <div className="row gap-lg-3 mt-3">
        <div className="col-lg">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            <div className="row">
              {
                <div className="col">
                  <label htmlFor="bankList" style={{ fontSize: "14px" }}>
                    List of banks dealt with by the company<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
              }

              <div className="col-lg-8">
                {masterData &&
                  statusFlag !== COMPLIANCE_NEW &&
                  masterData?.banks_list?.map((i, index) => (
                    <div className="mb-2" key={index}>
                      <input
                        disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                        type="text"
                        name={`bank${index}`}
                        id={`bank${index}`}
                        className="form-control bg-white"
                        placeholder={`Bank ${i}`}
                        value={
                          masterData &&
                          statusFlag === COMPLIANCE_REJECTED
                            ? rejectedBanks[index]
                            : i
                        }
                        onChange={(e) =>
                          handleBankChange(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
                {(masterData?.banks_list?.length === 0 ||
                  masterData?.length === 0 ||
                  statusFlag === COMPLIANCE_NEW) &&
                  [1, 2, 3, 4, 5].map((i,index) => (
                    <div className="mb-2" key={index}>
                      <input
                        disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                        type="text"
                        name={`bank${index}`}
                        id={`bank${index}`}
                        className="form-control bg-white"
                        placeholder={`Bank ${i}`}
                        value={updatedBanks[index]}
                        onChange={(e) =>
                          handleBankChange(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
          </form>
        </div>
      </div>}

      <div className={`${"mt-4"} "row gap-lg-3 "`}>
        <div className="col ">
          <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
            {masterData ? (
              <div className="row ">
                <div className="col-lg-4 mt-2">
                  <label htmlFor="number_of_employees">
                    <p style={{ fontSize: "14px" }}>
                      {" "}
                      Number of full-time employees<span style={{ color: "red" }}>*</span>
                    </p>
                  </label>
                </div>
                <div className="col">
                  <input
                    disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                    type="number"
                    name="no_of_full_time_employees"
                    id="no_of_full_time_employees"
                    className="form-control bg-white"
                    value={
                      masterData &&
                      (statusFlag === COMPLIANCE_PENDING ||
                        statusFlag === COMPLIANCE_APPROVED)
                        ? masterData.no_of_full_time_employees
                        : masterData &&
                          statusFlag === COMPLIANCE_REJECTED
                        ? rejectedDetails?.no_of_full_time_employees
                        : formData?.no_of_full_time_employees
                    }
                    placeholder="ex. 10 employees"
                    onChange={(e) =>
                      handleFieldChange(
                        "no_of_full_time_employees",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            ) : !masterData ? (
              <div className="row ">
                <div className="col-lg-4 mt-2">
                  <label htmlFor="number_of_employees">
                    <p style={{ fontSize: "14px" }}>
                      {" "}
                      Number of full-time employees
                    </p>
                  </label>
                </div>
                <div className="col">
                  <input
                    disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                    type="number"
                    name="no_of_full_time_employees"
                    id="no_of_full_time_employees"
                    className="form-control bg-white"
                    value={
                      masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.no_of_full_time_employees
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.no_of_full_time_employees
                  : formData?.no_of_full_time_employees
                    }
                    placeholder="ex. 10 employees"
                    onChange={(e) =>
                      handleFieldChange(
                        "no_of_full_time_employees",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </div>
      {role_code == INVESTOR_ROLE && 
        <div className={`${"mt-5"} "row gap-lg-3 "`}>
        <form className="form-group col me-1 custm_input_styl_stngs aksjdhf">
        <div className="row ">
                <div className="col-lg-4 mt-2">
                  <label htmlFor="number_of_employees">
                    <p style={{ fontSize: "14px" }}>
                      {" "}
                      Investment committed to BenneFin BSC (In USD) <span style={{color:"red"}}>*</span>
                    </p>
                  </label>
                </div>
                <div className="col">
                  <input
                    disabled={statusFlag === COMPLIANCE_APPROVED || rejectedFlag}
                    type="number"
                    name="committed_principal"
                    id="committed_principal"
                    className="form-control bg-white"
                    // value={
                    //   masterData
                    //     ? masterData?.committed_principal
                    //     : formData?.committed_principal
                    // }
                    value={
                masterData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                  ? masterData.committed_principal
                  : masterData && statusFlag === COMPLIANCE_REJECTED
                  ? rejectedDetails?.committed_principal
                  : formData?.committed_principal
              }

                    placeholder="Input amount in USD"
                    onChange={(e) =>
                      handleFieldChange(
                        "committed_principal",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              </form>
              </div>
      }

      {(getDocuments && statusFlag == COMPLIANCE_REJECTED) ||
      (masterData && statusFlag === COMPLIANCE_PENDING) ||
      statusFlag === COMPLIANCE_APPROVED ||
      statusFlag === COMPLIANCE_REJECTED ? (
        <div className=" border p-3 rounded mt-4">
          {getDocuments?.kyc_documents?.length !== 0 ? (
            <h6>Uploaded Documents </h6>
          ) : (
            <h6 className="fw-bold mb-0">No documents uploaded</h6>
          )}
         {getDocuments?.kyc_documents?.length>0 && <div className="upload_cls col  ">
            {getDocuments?.kyc_documents?.map((doc, index) => {
              return (
                <tr key={index}>
                  <td>
                    {doc.document_type == undefined ? "-" : doc.document_type}
                  </td>
                  <td>
                    <div className="d-flex justify-content-evenly">
                      <div className="align-self-center">
                        <a
                          style={{ display: "table-cell" }}
                          href={doc.document_url}
                          target="_blank"
                        >
                          <img src="./images/eye.svg" alt="" />
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </div>}
        </div>
      ) : (
        ""
      )}

      <div className="container px-0 pt-4 ms-0">
  <div className="form-group row">
    <label className="col-form-label col-md-4"><p style={{ fontSize: "14px" }}> Are you a politically exposed person<span style={{ color: "red" }}>*</span> </p></label>
    <div className="col-sm-6 custom-radio d-flex gap-5 align-items-center">
      <div className="custom-control custom-radio custom-control-inline d-inline-flex">
        <input type="radio" id="yesRadio" name="Yes" className=" "  checked={
           masterData &&
                      (statusFlag === COMPLIANCE_PENDING ||
                        statusFlag === COMPLIANCE_APPROVED)
                        ? masterData.is_pep ==="Yes"
                        : masterData &&
                          statusFlag === COMPLIANCE_REJECTED
                        ? rejectedDetails?.is_pep ==="Yes"
                        : formData?.is_pep ==="Yes"} onClick={(e) =>handleFieldChange("is_pep", "Yes")}/>
        <label className="mt-1 ms-1" for="yesRadio">Yes</label>
      </div>
      <div className="custom-control custom-radio custom-control-inline d-inline-flex">
        <input type="radio" id="noRadio" name="No" className=" " checked={masterData &&
                      (statusFlag === COMPLIANCE_PENDING ||
                        statusFlag === COMPLIANCE_APPROVED)
                        ? masterData.is_pep ==="No"
                        : masterData &&
                          statusFlag === COMPLIANCE_REJECTED
                        ? rejectedDetails?.is_pep ==="No"
                        : formData?.is_pep ==="No"} onClick={(e) =>handleFieldChange("is_pep", "No" )}/>
        <label className="mt-1 ms-1" for="noRadio">No</label>
      </div>
    </div>
  </div>
</div>
     {dataUser?.kyc?.length === 0 ||
            statusFlag === COMPLIANCE_REJECTED ||
             statusFlag ===COMPLIANCE_NEW ? 
             <div className="row mt-5">
               <h6>
                 Upload Documents{" "}
               </h6>
               <p>
               Please upload any documents relevant to this loan, including any
               invoices, or other documents.{" "}
                 <span style={{ color: "red" }}>
                   {" "}
                   (File size should be less than 5 MB *)
                 </span>
               </p>
               <div className="upload_cls col  ">
                 {
                             handleIsDataNull?
                     (download.map((item, index) => {
                       return (
                         <div key={item.doc_type} className="row align-items-baseline">
                           <div className="col-lg-4 text-start mt-2 text-wrap ">
                             <article>
                               {item.doc_type}
                               {item.doc_type==="Others" && <span style={{ fontSize:"11px" }}>
                   {" "}
                   (Max 50 files *)
                 </span>}
                               {statusFlag !== COMPLIANCE_REJECTED && (
                                 (typeof item.doc_type === 'string' && 
                                  item.doc_type &&
                                  !item.doc_type.includes('Resident Visa') &&
                                   !item.doc_type.includes('Valid Tenancy contract for Office or utility bill within last 3 months') &&
                                   !item.doc_type.includes('Valid Tenancy contract of the signatory as residence proof') &&
                                   !item.doc_type.includes('Share Certificate / Registry') &&
                                   (
                                    (role_code === BUSINESS_ROLE && !item.doc_type.includes('Board Resolution Document') && !item.doc_type.includes('Others')) ||
                                    (role_code === INVESTOR_ROLE && !item.doc_type.includes('Others'))
                                  )
                                  ) ?
                                   <span className="text-danger fs-5">*</span> : ""
                               )}
                             </article>     
                           </div>
                           <div className="col-lg-2">
                             <label className="d-flex">
                               <img
                                 src="./images/icons/plus_symbol.svg"
                                 alt="UploadFile"
                               />
                               <span className="me-3 text-start">
                                 {" "}
                                 {!item.is_upload ? "Upload File" : " Uploaded"}
                               </span>
                               <input
                                 className="custom-file-input"
                                 type="file"
                                 onChange={(e) => handleChange(e, item, index)}
                                 ref={fileInputRef}
                                 multiple={item.doc_type === "Others"}
                               />
                             </label>
                           </div>
                           <div className="col-lg-5 ">
                             {item.is_upload ?
                               <div>
                                 {item.doc_type === "Others" ? (
                                   <div style={{height:"100px",overflowY:"auto"}}>
                                     {others.map((doc) => (
                                       <span>
                                         <a
                                           style={{ cursor: "pointer" }}
                                         >
                                           <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                             data-bs-placement="top"
                                             title="Click to view image" onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)} />
                                         </a>{" "}
                                         <span className="input_filname"
     
                                           data-bs-toggle="tooltip"
                                           data-bs-placement="top"
                                           title={doc instanceof File ? doc.name : doc.document_type}
                                           style={{
                                             display: "inline-block",
                                             maxWidth: "300px",
                                             overflow: "hidden",
                                             whiteSpace: "nowrap",
                                           }}
                                         >
                                           {" "}
                                           {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}
                                         </span>
                                         <span
                                           onClick={() => handleDeleteClickOthers(doc)}
                                         >
                                           <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{marginLeft:"10px"}}/>
                                         </span>
                                         <br />
                                       </span>
     
                                     ))}
                                   </div>
                                 ):(
                                   <span>
                                     <a
                                       style={{ display: "table-cell", cursor: "pointer" }}
                                     >
                                       <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                         data-bs-placement="top"
                                         title="Click to view image" onClick={(e) => handleChangeDownload(e, item)}/>
                                     </a>{" "}
                                     <span className="input_filname"
     
                                       data-bs-toggle="tooltip"
                                       data-bs-placement="top"
                                       title={item.file_name}
                                     >
                                       {" "}
                                             {item.file_name?.length > 50
                                               ? item.file_name.slice(0, 50) + "..."
                                               : item.file_name}
                                     </span>
                                     <span
                                       onClick={() => handleDeleteClick(item)}                                  
                                     >
                                           <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2"/>
                                     </span>
                                   </span>
                                 )}
                               </div> : (
                                 ""
                               )}
                           </div>
                         </div>
                       );
                             })):
                             (
                              mergedDownloads.map((item, index) => {
                         return (
                           <div key={item.doc_type} className="row align-items-baseline">
                             <div className="col-lg-4 text-start mt-2 text-wrap ">
                               <article>
                                 {item.doc_type}
                                 {item.doc_type==="Others" && <span style={{ fontSize:"11px" }}>
                   {" "}
                   (Max 50 files *)
                 </span>}
                                 {statusFlag !== COMPLIANCE_REJECTED && (
                                   (!item.doc_type.includes('Resident Visa') &&
                                     !item.doc_type.includes('Valid Tenancy contract for Office or utility bill within last 3 months') &&
                                     !item.doc_type.includes('Valid Tenancy contract of the signatory as residence proof') &&
                                     !item.doc_type.includes('Share Certificate / Registry') &&
                                     (
                                      (role_code === BUSINESS_ROLE && !item.doc_type.includes('Board Resolution Document') && !item.doc_type.includes('Others')) ||
                                      (role_code === INVESTOR_ROLE && !item.doc_type.includes('Others'))
                                    )
                                    )
                                     ? <span className="text-danger fs-5">*</span> : ""
                                 )}
                               </article>
     
                             </div>
                             <div className="col-lg-2">
                               <label className="d-flex">
                                 <img
                                   src="./images/icons/plus_symbol.svg"
                                   alt="UploadFile"
                                 />
                                 <span className="me-3 text-start">
                                   {" "}
                                   {!item.is_upload ? "Upload File" : " Uploaded"}            
                                 </span>
                                 <input
                                   ref={fileInputRef}
                                   className="custom-file-input"
                                   type="file"
                                   multiple={item.doc_type === "Others"}
                                   onChange={(e) => handleChange(e, item, index)}
                                   style={{ display: "none" }}
                                 />
                               </label>
                             </div>
                             <div className="col-lg-5 ">
                               {item.is_upload ? (
                                 <div>
                                   {item.doc_type === "Others" ? (
                                     <div style={{height:"100px",overflowY:"auto"}}>
                                       {others.map((doc)=>(
                                         <span>
                                           <a
                                             style={{ cursor: "pointer" }}
                                           >
                                             <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                               data-bs-placement="top"
                                               title="Click to view image" onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)} />
                                           </a>{" "}
                                           <span className="input_filname"
     
                                             data-bs-toggle="tooltip"
                                             data-bs-placement="top"
                                             title={doc instanceof File ? doc.name : doc.document_type}
                                             style={{
                                               display: "inline-block",
                                               maxWidth: "300px",
                                               overflow: "hidden",
                                               whiteSpace: "nowrap",
                                             }}
                                           >
                                             {" "}
                                             {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}

                                           </span>
                                           <span
                                             onClick={() => handleDeleteClickOthers(doc)}
                                           >
                                             <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{marginLeft:"10px"}}/>
                                           </span>
                                           <br />
                                         </span>
     
                                       ))}
                                     </div>
                                   ):(
                                     <span>
                                       <a
                                         style={{ display: "table-cell", cursor: "pointer" }}
                                       >
                                         <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                           data-bs-placement="top"
                                           title="Click to view image" onClick={(e) => handleChangeDownload(e, item)} />
                                       </a>{" "}
                                       <span className="input_filname"
                                         data-bs-toggle="tooltip"
                                         data-bs-placement="top"
                                         title={item.file_name}
                                       >
                                         {" "}
                                         {item.file_name.length > 50 ? item.file_name.slice(0, 50) + "..." : item.file_name}
                                       </span>
                                       <span
                                         onClick={() => handleDeleteClick(item)}
                                       >
                                         <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" />
                                       </span>
                                     </span>
                                   )}
                                 </div>
                               ) : (
                                 ""
                               )}
                             </div>
                           </div>
                         );
                       }))
                 }
               </div>
             </div>:""
           }
      
<div className="settingsSavebtn">
<Button 
    variant="secondary" 
    className="me-2"
    disabled={statusFlag === COMPLIANCE_PENDING || statusFlag === COMPLIANCE_APPROVED ||saveKYCBtn}
    onClick={role_code===BUSINESS_ROLE? handleSaveDraft:
      Cookies.get("investor_type")==="institution"?handleSaveDraftCompany:handleSaveDraft}
  >
    Save Draft
  </Button>

        {(dataUser?.kyc?.length === 0 ||
          statusFlag === COMPLIANCE_NEW ||
          masterData?.length === 0) && (
            role_code === BUSINESS_ROLE ? <button
              disabled={statusFlag === COMPLIANCE_PENDING || statusFlag === COMPLIANCE_APPROVED ||saveKYCBtn}
              className="btn blue_btn "
              onClick={handleSubmit(handleSavechanges)}
            >
              Submit
            </button> : <button
              disabled={statusFlag === COMPLIANCE_PENDING || statusFlag === COMPLIANCE_APPROVED||saveKYCBtn}
              className="btn blue_btn "
              onClick={handleSubmit(handleSavechanges)}
            >
              Submit
            </button>
          )}
        {statusFlag === COMPLIANCE_REJECTED && (
          <button
            disabled={saveKYCBtn}
            className="btn blue_btn "
            onClick={handleSubmit(handleUpdateKyc)}
          >
            Update
          </button>
        )}

      </div>

    </p>
  );
};

 
